import { ArrowRight } from "lucide-react";
import { Button, Photo, Section, withHighlight } from "@/components/ui";
import { ABOUT_CLOSING } from "@/data/about";
import { PHOTOS } from "@/data/photos";

/** Closing band on the About page: message and button beside a campus photo. */
export function AboutClosingCta() {
  const { line1, line2, highlight, cta } = ABOUT_CLOSING;
  return (
    <Section tone="brandTint" labelledBy="about-closing-title" testId="about-closing" spacing="roomy">
      <div className="relative z-10 grid items-center gap-8 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-6">
          <h2
            id="about-closing-title"
            className="font-heading text-3xl font-bold leading-[1.1] sm:text-4xl lg:text-5xl"
          >
            {line1}
            <span className="mt-3 block">{withHighlight(line2, highlight)}</span>
          </h2>
          <div className="mt-8">
            <Button to={cta.to} size="lg" data-testid="about-closing-cta">
              {cta.label}
              <ArrowRight className="h-5 w-5" aria-hidden="true" />
            </Button>
          </div>
        </div>
        <div className="lg:col-span-6">
          <Photo
            photo={PHOTOS.avenue}
            ratio="aspect-[4/3]"
            imgClassName="object-[50%_60%]"
            sizes="(min-width: 1024px) 560px, 100vw"
            testId="about-closing-photo"
          />
        </div>
      </div>
    </Section>
  );
}
